const SESSION_TOKEN_KEY = 'pharmaSoftToken';

export const readSessionToken = (): string | null => sessionStorage.getItem(SESSION_TOKEN_KEY);

export const saveSessionToken = (token: string): void => sessionStorage.setItem(SESSION_TOKEN_KEY, token);

export const clearSessionToken = (): void => sessionStorage.removeItem(SESSION_TOKEN_KEY);
